import MenuBar from '../MenuBar/MenuBar';
import React, { useEffect } from 'react';
import {
    Switch,
    Route,
} from "react-router-dom";
import Login from '../Login/Login';
import { userProfileSelector } from '../Login/reducers/UserProfileReducer';
import { useDispatch, useSelector } from 'react-redux';
import Tonnage from '../Tonnage/Tonnage';
import Cargo from '../Cargo/Cargo';
import MatchingPreview from '../MatchingPreview/MatchingPreview';
import DraggableMenu from '../DraggableMenu/DraggableMenu';
import QuickInput from '../QuickInput/QuickInput';
import MarketingMatchingResults from '../MatchingPreview/MarketingMatchingResults';
import Contact from '../Contact/Contact';
import { contactInputSelector, setStaticResources } from '../Contact/reducers/ContactInputReducer';
import ContactApi from '../Contact/api/ContactApi';
import BaseResponse from '../../app/BaseResponse';
import ContactStaticResourcesModel from '../Contact/models/ContactStaticResourcesModel';
import Utility from '../../app/utility';
import AdminTools from '../AdminTools/AdminTools';
import MarketInfo from '../MarketInfo/MarketInfo';
import BookmarkModal from '../PortSelector/BookmarkModal';
import Stat from '../Stat/Stat';
import MarketingEmail from '../MarketingEmail/MarketingEmail';
import Fixture from '../FixtureManagement/Fixture';
import SupportSheet from '../SupportSheet/SupportSheet';
import TonnageApi from '../Tonnage/api/TonnageApi';
import TonnageNameModel from '../Tonnage/models/TonnageNameModel';
import { setTonnageNames } from '../Tonnage/reducers/TonnageInputReducer';
import MyFixture from '../MyFixtures/MyFixture';
import Agent from '../Agent/Agent';
import CompanyNamePIC from '../CompanyNamePIC/CompanyNamePIC';
import Surveyor from '../Surveyor/Surveyor';
import PortSelectorApi from '../PortSelector/api/PortSelectorApi';
import AreaModel from '../PortSelector/models/AreaModel';
import PortModel from '../PortSelector/models/PortModel';
import { portSelectorSelector, setAreas, setMasterAreas, setPorts } from '../PortSelector/reducers/PortSelectorReducer';
import _ from 'lodash';
import Cash from '../Cash/Cash';
import Investment from '../Investment/Investment';
import Expense from '../Expense/Expense';
import Care from '../Care/Care';
import Stock from '../Stock/Stock';
import TotalSummary from '../TotalSummary/TotalSummary';
import Classification from '../Classification/Classification';
import BrokerAccount from '../BrokerAccount/BrokerAccount';

const AppLayout: React.FunctionComponent = () => {
    const userProfile = useSelector(userProfileSelector);
    const dispatch = useDispatch();
    const contactInputViewData = useSelector(contactInputSelector);
    let portSelectorData = useSelector(portSelectorSelector);

    useEffect(() => {
        if (contactInputViewData.staticResources.companyTypes.length === 0 && userProfile.email.length) {
            ContactApi.GetStaticResources()
                .then((response: BaseResponse<ContactStaticResourcesModel>) => {
                    if (response.success) {
                        dispatch(setStaticResources(response.data))
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                }).catch((error) => {
                    Utility.Alert.Error(error);
                })
        }
    }, [userProfile.email]);


    useEffect(() => {
        getTonnageNames();
        setInterval(() => {
            //refresh  tonnage names each 10 minutes
            getTonnageNames();
        }, 1000 * 60 * 10);
    }, [])

    useEffect(() => {
        if (userProfile.email.length == 0) {
            return;
        }

        PortSelectorApi.GetAll()
            .then((response: BaseResponse<PortModel[]>) => {
                if (response.success) {
                    let areas: AreaModel[] = [];

                    _.each(response.data, (port) => {
                        let selectedArea = _.find(areas, (area: AreaModel) => {
                            return area.name === port.area;
                        });

                        if (!selectedArea) {
                            areas.push({
                                name: port.area,
                                positive: true
                            } as AreaModel);
                        }

                        port.positive = true;
                    });

                    let masterAreas = _.keys(_.groupBy(response.data, (port) => {
                        return port.masterArea;
                    }));

                    masterAreas = _.filter(masterAreas, (masterArea) => {
                        return masterArea != "null" && masterArea.length > 0;
                    })

                    dispatch(setPorts(response.data));
                    dispatch(setAreas(areas));
                    dispatch(setMasterAreas(masterAreas));
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                Utility.Alert.Error(error);
            });
    }, [portSelectorData.triggerRefreshTable]);

    const getTonnageNames = () => {
        if (userProfile.email.length == 0) {
            return;
        }

        TonnageApi.GetAllNames()
            .then((response: BaseResponse<TonnageNameModel[]>) => {
                if (response.success) {
                    dispatch(setTonnageNames(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                Utility.Alert.Error(error);
            })
    }

    return (
        <>
            <MatchingPreview>
            </MatchingPreview>
            <MarketingMatchingResults>
            </MarketingMatchingResults>
            <QuickInput>
            </QuickInput>
            <DraggableMenu></DraggableMenu>
            {
                userProfile.email &&
                <MenuBar></MenuBar>
            }
            <BookmarkModal></BookmarkModal>
            <main>
                <Switch>
                    <Route path="/companynamepic">
                        <CompanyNamePIC></CompanyNamePIC>
                    </Route>
                    <Route path="/expense">
                        <Expense type='Expense' key='expense'></Expense>
                    </Route>
                    <Route path="/cash">
                        <Cash></Cash>
                    </Route>
                    <Route path="/care">
                        <Care></Care>
                    </Route>
                    <Route path="/stock">
                        <Stock></Stock>
                    </Route>
                    <Route path="/investment">
                        <Investment></Investment>
                    </Route>
                    <Route path="/classification">
                        <Classification></Classification>
                    </Route>
                    <Route path="/agent">
                        <Agent></Agent>
                    </Route>
                    <Route path="/surveyor">
                        <Surveyor></Surveyor>
                    </Route>
                    <Route path="/support">
                        <MyFixture></MyFixture>
                    </Route>
                    <Route path="/summary">
                        <Fixture></Fixture>
                    </Route>
                    <Route path="/support-sheet">
                        <SupportSheet></SupportSheet>
                    </Route>
                    <Route path="/tonnage">
                        <Tonnage></Tonnage>
                    </Route>
                    <Route path="/cargo">
                        <Cargo></Cargo>
                    </Route>
                    <Route path="/contact">
                        <Contact></Contact>
                    </Route>
                    <Route path="/marketinfo">
                        <MarketInfo></MarketInfo>
                    </Route>
                    <Route path="/login">
                        {
                            !userProfile.email &&
                            <Login></Login>
                        }
                    </Route>
                    <Route path="/stats">
                        <Stat></Stat>
                    </Route>
                    <Route path="/brokeraccount">
                        <BrokerAccount></BrokerAccount>
                    </Route>
                    <Route path="/marketingemail">
                        <MarketingEmail key="marketingemail" system="AscentBulk"></MarketingEmail>
                    </Route>
                    <Route path="/evbemail">
                        <MarketingEmail key="evobulk" system="EvoBulk"></MarketingEmail>
                    </Route>
                    <Route path="/admintools">
                        <AdminTools></AdminTools>
                    </Route>
                    <Route path="/totalsummary">
                        <TotalSummary></TotalSummary>
                    </Route>
                    <Route path="/">
                        <Tonnage></Tonnage>
                    </Route>
                </Switch>
            </main>
        </>
    )
};

export default AppLayout;